export default __webpack_public_path__ + "static/media/mix1.f846dc56.jpg";